import { useEffect, useState } from 'react';
import { CLOUD_FUNCTION_URL_EUW2 } from '../env';

const useValidateToken = (token: string | null) => {
  const [isValid, setIsValid] = useState<boolean>(false);
  const [isValidating, setIsValidating] = useState<boolean>(true);
  const [email, setEmail] = useState<string | null>(null);

  useEffect(() => {
    if (!token) {
      setIsValid(false);
      setIsValidating(false);
      return;
    }
    const validate = async () => {
      try {
        const response = await fetch(`${CLOUD_FUNCTION_URL_EUW2}/validateToken`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` }
        });

        if (!response.ok) {
          setIsValid(false);
          return;
        }

        const { data } = await response.json();
        setEmail(data?.email ?? null);
        setIsValid(true);
      } catch {
        setIsValid(false);
      } finally {
        setIsValidating(false);
      }
    };

    validate();
  }, [token]);
  return { isValid, isValidating, email };
};

export default useValidateToken;
